import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class Ultraship_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public Ultraship: Ultraship_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

